import { Controller } from "@hotwired/stimulus"

// The home page hero's "I love wine / I sell wine" switch. It shows one
// audience's headline, bullets, call to action and preview at a time, and
// trades them on its own until somebody picks a side.
export default class extends Controller {
  static targets = ["switch", "button", "panel"]
  static values = { interval: { type: Number, default: 12000 } }

  connect() {
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return this.halt()

    this.switchTarget.style.setProperty("--www-tick", `${this.intervalValue}ms`)
    this.timer = setInterval(() => this.show(this.current === "lovers" ? "pros" : "lovers"), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  choose(event) {
    this.halt()
    this.show(event.currentTarget.dataset.audience)
  }

  show(audience) {
    this.switchTarget.dataset.on = audience
    this.buttonTargets.forEach((button) => button.setAttribute("aria-pressed", String(button.dataset.audience === audience)))
    this.panelTargets.forEach((panel) => { panel.hidden = panel.dataset.audience !== audience })
  }

  halt() {
    clearInterval(this.timer)
    this.switchTarget.classList.add("is-stopped")
  }

  get current() {
    return this.switchTarget.dataset.on
  }
}
